export default "__VITE_ASSET__DsL9dQpq__"